import { render, staticRenderFns } from "./FeaturedPosts.vue?vue&type=template&id=1dce2217&scoped=true&"
import script from "./FeaturedPosts.vue?vue&type=script&lang=js&"
export * from "./FeaturedPosts.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPosts.vue?vue&type=style&index=0&id=1dce2217&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dce2217",
  null
  
)

export default component.exports